import { useContext } from 'react';

import { fg } from '@confluence/feature-gating';
import { RoutesContext } from '@confluence/route-manager/entry-points/RoutesContext.ts';

const AI_PLANNER_PARENT_PRODUCT = 'ai-planner';

export function useIsAIPlannerBridgeRoute(): boolean {
	const { location } = useContext(RoutesContext);
	const search = location?.search ?? '';

	return (
		fg('confluence_ai_planner_rovo_bridge_streaming') &&
		new URLSearchParams(search).get('parentProduct') === AI_PLANNER_PARENT_PRODUCT
	);
}
